import { useEffect, useState } from 'react';
import { Box } from '@gemini/core';
import { CheckIcon } from '@gemini/icons';

const LoadingMessage = ({ text, displayedAfter }: { text: string; displayedAfter: number }) => {
    const [isDisplayed, setIsDisplayed] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsDisplayed(true), displayedAfter);
        return () => clearTimeout(timer);
    }, []);

    return isDisplayed ? (
        <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            marginVertical="spacing.16"
            marginHorizontal={{
                'breakpoint.base': 'spacing.none',
                'breakpoint.xs': 'spacing.8',
            }}
        >
            <CheckIcon />
            <Box
                as="p"
                typography="typography.body.14.regular"
                color="color.content.default.default"
                padding="spacing.none"
                paddingLeft="10px"
                margin="spacing.none"
            >
                {text}
            </Box>
        </Box>
    ) : null;
};

export default LoadingMessage;
